import CommonFunction from '@/common/commonFunction';

import { defaultTaxReturnSubmissionState } from './module-taxreturnsubmission-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxReturnSubmissionState);
	},
	updateTaxReturnsSumission(state, res) {
		state.TaxReturnSubmissionData.removeAll();
		if (res.Data) {
			CommonFunction.genVKeyValue(res.Data);
			state.TaxReturnSubmissionData.append(res.Data);
		}

		if (res.Total) {
			state.Total = res.Total;
		} else {
			state.Total = 0;
		}
	},
	updateQuickSearchText(state, text) {
		state.CachedQuickSearchText = text;
	},
	updateCondition(state, payload) {
		//Kiểm tra params có dữ liệu mới cache lại
		if (!payload || !Object.keys(payload)) return;
		
		state.CachedFilterOptions = payload;
	},
	updateFilterDisplay(state, payload) {
		state.CachedFilterDisplay = payload || {};
	},
	updateAppendixData(state, data) {
		state.AppendixTaxReturnSubmissionData = data;
	},
	updateTaxReturnSubmissionHistoriesPagingData(state, data) {
		if (data) {
			state.TaxReturnSubmissionHistoryData = data.Data;
			state.TotalSubmissionHistoryData = data.Total;
		}
	},
	updateEmptyTaxReturnSubmissionHitoriesPaging(state, data) {
		state.TaxReturnSubmissionHistoryData = [];
		state.TotalSubmissionHistoryData = 0;
	},
	updateLoading(state, payload) {
		state.IsLoadingPaper = payload;
	},
	updateTaxReturnHavePaidReportData: function(state, data) {
		if (data) state.TaxReturnHavePaidReportData = data;
	}
};
